module.exports = __webpack_public_path__ + "img/errorThumbnailImage@3_200x200.7a2bfcc0.png";